import { render } from "./vsharedvcinstall.vue?vue&type=template&id=bb85aea2&scoped=true"
import script from "./vsharedvcinstall.vue?vue&type=script&lang=js"
export * from "./vsharedvcinstall.vue?vue&type=script&lang=js"

import "./vsharedvcinstall.vue?vue&type=style&index=0&id=bb85aea2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb85aea2"]])

export default __exports__